exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container.settings-options[data-v-12241665] {\n  max-width: 600px;\n}\n", ""]);

// exports
